import * as z from 'zod';
import { FORM_FIELD_CHARACTER_LIMITS } from './form-field-character-limits';

export interface CommonInputProperties {
  name: string;
  label?: string;
  placeholder?: string;
  labelPosition?: 'top' | 'left';
  required?: boolean;
}

export function createCommonInputValidationSchema() {
  return z.object({
    name: z
      .string()
      .min(1, 'O nome é obrigatório')
      .max(FORM_FIELD_CHARACTER_LIMITS.FIELD_ID),
    label: z
      .string()
      .max(FORM_FIELD_CHARACTER_LIMITS.LABEL)
      .optional(),
    placeholder: z
      .string()
      .max(FORM_FIELD_CHARACTER_LIMITS.AUXILIARY_TEXT)
      .optional(),
    labelPosition: z.enum(['top', 'left']).optional(),
    required: z.boolean().optional(),
  });
}

export function extractCommonInputValues<T extends CommonInputProperties>(
  properties: T | undefined
): CommonInputProperties {
  return {
    name: properties?.name || '',
    label: properties?.label || '',
    placeholder: properties?.placeholder || '',
    labelPosition: properties?.labelPosition || 'top',
    required: properties?.required || false,
  };
}

export function mapCommonInputValuesToProperties<T extends CommonInputProperties>(
  values: CommonInputProperties,
  currentProperties: T
): { properties: T } {
  return {
    properties: {
      ...currentProperties,
      name: values.name || currentProperties.name,
      label: values.label || undefined,
      placeholder: values.placeholder || undefined,
      labelPosition: values.labelPosition,
      required: values.required ?? false,
    },
  };
}
